import { createAction } from 'redux-starter-kit';

export const SET_RISK_MAPPING = 'SET-RISK_MAPPING-RESULTS/';

export const ADD_TO_RISK_MAPPING_REQUEST_COUNT =
  'ADD_TO-RISK_MAPPING-REQUEST_COUNT/';

export const TAKE_FROM_RISK_MAPPING_REQUEST_COUNT =
  'TAKE_FROM_RISK_MAPPING_REQUEST_COUNT/';

export const setRiskMappingResults = createAction(SET_RISK_MAPPING);

export const addToRiskMappingRequestCount = createAction(
  ADD_TO_RISK_MAPPING_REQUEST_COUNT
);

export const takeFromRiskMappingRequestCount = createAction(
  TAKE_FROM_RISK_MAPPING_REQUEST_COUNT
);

export const riskMappingActions = {
  setRiskMappingResults,
  addToRiskMappingRequestCount,
  takeFromRiskMappingRequestCount
};
